import { Shape } from './Shape.js';
import { fabric } from 'fabric';
import { ShapeAction } from './ShapeFactory.js';
//const fabric = window.fabric;
var defaultProps = {
    top: 0,
    left: 0,
    hasBorder: true,
    stroke: 'red',
    strokeWidth: 3,
    fill: '',
    originX: 'left',
    originY: 'top'
};
class Rectangle extends Shape {
    constructor(props) {
        super(props);
        this.rect = null;
        this.origX = 0;
        this.origY = 0;
    }
    draw(props) {
        this.newProps = {
            ...defaultProps,
            ...props
        };

        //working while snapsot
        if (props.action !== ShapeAction.START) {
            let canvasObject = new fabric.Rect(props);
            super.draw(canvasObject);
            return;
        }
        const events = {
            onCanvasMouseDown: this.onMouseDown.bind(this),
            onCanvasMouseUp: this.onMouseUp.bind(this),
            onCanvasMouseMove: this.onMouseMove.bind(this)
        };

        this.drawingCanvas.registerEvents(events);
    }
    onMouseMove(pointer) {
        if (this.rect) {
            if (this.origX > pointer.x) {
                this.rect.set({ left: Math.abs(pointer.x) });
            }
            if (this.origY > pointer.y) {
                this.rect.set({ top: Math.abs(pointer.y) });
            }

            this.rect.set({ width: Math.abs(this.origX - pointer.x) });
            this.rect.set({ height: Math.abs(this.origY - pointer.y) });
        }
    }
    onMouseDown(points) {        
        [this.origX, this.origY] = points;

        this.newProps = { ...this.newProps, left: this.origX, top: this.origY };

        this.rect = new fabric.Rect(this.newProps);
        this.rect.uuid = this.newProps.uuid;
        this.rect.uuid_parent = this.newProps.uuid_parent;
        this.drawingCanvas.addAsActiveShape(this.rect);
        //this.drawingCanvas.renderAll();
    }

    onMouseUp() {
        this.drawingCanvas.removeEvents();
        this.newProps.action = ShapeAction.ADD;
        super.toFebricObject(this.rect);
        if (this.onDrawCompleted) {
            this.onDrawCompleted({
                ...this.newProps,
                ...this.rect.toObject()
            });
        }
    }
}

export { Rectangle };
